import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { CorporatePaths } from 'src/components/AppRoutes/Enterprise/CorporatePaths';
import {
  CorporateCreateRoute,
  CorporateEditRoute,
} from 'src/components/AppRoutes/CorporateRoutes.layout';

export const CorporateRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route
        exact
        path={CorporatePaths.create}
        component={CorporateCreateRoute}
      />
      <Route exact path={CorporatePaths.edit} component={CorporateEditRoute} />
    </Switch>
  );
};
